import { post } from './http'

const baseUrl = '/api/meas/admin/system'

// 获取账号列表
export const getAccountList = data => post(`${baseUrl}/role/getAccountList`, data)

// 获取账号详情
export const getAccountDetails = data => post(`${baseUrl}/role/getAccountDetails`, data)

// 新增编辑账号 
export const saveAccountInfo = data => post(`${baseUrl}/role/saveAccountInfo`, data)

// 删除账号 
export const deleteAccount = data => post(`${baseUrl}/role/deleteAccount`, data)

// 获取日志列表
export const getLogList = data => post(`${baseUrl}/log/getLogList`, data)

// 获取时段列表
export const getTimeconfigList = data => post(`${baseUrl}/time/getTimeconfigList`, data)

// 新增时段
export const saveTimeconfig = data => post(`${baseUrl}/time/saveTimeconfig`, data)

// 删除时段
export const deleteTimeconfig = data => post(`${baseUrl}/time/deleteTimeconfig`, data)